/**
 * Finish: sensor trigger volume rendered as a checkered flag column.
 */

import Matter from 'matter-js';
import { Graphics } from 'pixi.js';

export interface FinishOptions {
  x: number;
  y: number;
  w: number;
  h: number;
}

export class Finish {
  readonly body: Matter.Body;
  readonly view: Graphics;

  constructor(opts: FinishOptions) {
    this.body = Matter.Bodies.rectangle(
      opts.x + opts.w / 2,
      opts.y + opts.h / 2,
      opts.w,
      opts.h,
      { isStatic: true, isSensor: true, label: 'finish' },
    );

    const g = new Graphics();
    const cell = 20;
    const cols = Math.max(1, Math.ceil(opts.w / cell));
    const rows = Math.max(1, Math.ceil(opts.h / cell));
    for (let r = 0; r < rows; r++) {
      for (let c = 0; c < cols; c++) {
        const dark = (r + c) % 2 === 0;
        g.rect(opts.x + c * cell, opts.y + r * cell, cell, cell).fill(
          dark ? 0x111111 : 0xeeeeee,
        );
      }
    }
    this.view = g;
  }
}
